import { useEffect } from 'react';

/**
 * Sets a temporary <meta name="robots" content="noindex, nofollow"> while mounted.
 * Useful for auth/share pages that shouldn't be indexed.
 */
export function useNoIndex() {
  useEffect(() => {
    const head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return;

    const existing = head.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    const prevContent = existing?.getAttribute('content') || null;

    let node = existing;
    if (!node) {
      node = document.createElement('meta');
      node.setAttribute('name', 'robots');
      head.appendChild(node);
    }
    node.setAttribute('content', 'noindex, nofollow');

    return () => {
      if (!node) return;
      if (prevContent) node.setAttribute('content', prevContent);
      else head.removeChild(node);
    };
  }, []);
}

export default useNoIndex;

